import React from 'react';
import '../../Styles/LoadingOverlay.css';

interface LoadingOverlayProps {
  message?: string;
  isLoading?: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message, isLoading = true }) => {
  if (!isLoading) return null;

  return (
    <div className="loading-overlay" role="alert" aria-busy="true">
      <div className="loading-content">
        <div className="loading-spinner"></div>
        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default LoadingOverlay;